import {HSConsent} from "server-openapi";
import {DateUtils} from "./dateUtils";

function formatMedicare(medicareCardNumber: string | number | null | undefined): string {
    if (typeof medicareCardNumber === "number") {
        medicareCardNumber = medicareCardNumber.toString();
    }
    if (typeof medicareCardNumber !== "string") {
        return "";
    }

    const cn = stripSpaces(medicareCardNumber);

    const c1 = cn.substring(0, 4);
    const c2 = cn.substring(4, 9);
    const c3 = cn.substring(9, 10);
    return `${c1} ${c2} ${c3}`;
}

export function displayMedicare(medicareCardNumber: string | number | null | undefined, irn: string | number | null | undefined = undefined): string | null {
    if (!irn && typeof medicareCardNumber === "string" && medicareCardNumber.length === 11) {
        irn = medicareCardNumber.substring(10);
        medicareCardNumber = medicareCardNumber.substring(0, 10);
    }
    medicareCardNumber = formatMedicare(medicareCardNumber);
    if (!medicareCardNumber) {
        return null;
    }

    return irn ? `${medicareCardNumber}/${irn}` : medicareCardNumber;
}

function stripSpaces(s: string | null | undefined): string {
    s = s ?? "";
    return s.trim().replace(/\s+/g, "");
}

export function formatIhi(hi: string | undefined | null): string {
    const n = stripSpaces(hi);
    if (n.length === 16) {
        return `${n.slice(0, 4)} ${n.slice(4, 8)} ${n.slice(8, 12)} ${n.slice(12)}`;
    }
    return n;
}
